import React from "react";
import AppRouter from "./router";
import { ConfigProvider } from "antd";
import GTM from "./components/components/GTM/GTM";


function App() {
  return <ConfigProvider
    theme={{
      token: {
        colorPrimary: "#d4b483",
      },
    }}
  >
    <GTM></GTM>
    <AppRouter />
  </ConfigProvider>
}

export default App;